export default "__VITE_ASSET__DY2iS31N__"